export default "__VITE_ASSET__9B6f2UcT__"